<script setup lang="ts">
import CorporateDocumentsHero from '@/domains/investor/corporate-governance/corporate-documents/components/Hero/Hero.vue'
import CorporateDocumentsTabs  from '@/domains/investor/corporate-governance/corporate-documents/components/Tabs/Tabs.vue'
import FileList from '@/domains/investor/components/FileList/FileList.vue'

import { useTabs } from '~/domains/investor/corporate-governance/corporate-documents/composables/useTabs';
import type { ICorporateDocumentsTabs } from "@/domains/investor/corporate-governance/corporate-documents/types/Document.tabs.types"

const { documentsTabs } = useTabs()
const { t, locale } = useI18n()
let fetchAll = ref(true)
let showList = ref(documentsTabs.value[0])

const changeTab = (event: ICorporateDocumentsTabs) => {
  showList.value = event
  fetchAll.value = event.mode === 'all'
}

useHead(() => ({
  title: t('pageTitles.investorCorporateDocuments.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.investorCorporateDocuments.meta'),
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: t(`pageTitles.investorCorporateDocuments.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.investorCorporateDocuments.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.investorCorporateDocuments.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.investorCorporateDocuments.canonical.pl'),
    },
  ],
}))

definePageMeta({
  layout: 'investor',
})

const getTabs = computed(() => {
  return documentsTabs.value.filter(tab => !tab.mode)
})

</script>


<template>
    <CorporateDocumentsHero />

    <UiSection>
      <div class="corporateDocumentationPage__container">
        <UiHeader
          :header="$t('investor.corporateGovernance.corporateDocuments.header.title')"
          position="center"
          header-size-mobile="h5"
          header-size="h5"
        />
  
        <CorporateDocumentsTabs
          v-model="showList"
          :document-tabs="documentsTabs"
          @update:model-value="changeTab($event)"
        />
  
        <UiHeader
          :header="$t('investor.corporateGovernance.corporateDocuments.fileList.title')"
          header-size-mobile="h10"
          header-size="h10"
        />
      </div>

      <template
        v-for="tab in getTabs"
      >
        <KeepAlive>
          <FileList
            v-if="fetchAll || (tab.fileListId != null && tab.fileListId === showList.fileListId)"
            variant="list"
            :request-id="tab.fileListId!"
            :key="tab.fileListId"
            :show-title="false"
            :file-item-link-options="{
              label: $t('investor.corporateGovernance.corporateDocuments.fileList.label')            
            }"
            :file-item-options="{
              showFormat: true,
              showSize: true,
            }"
          />
        </KeepAlive>
      </template>

    </UiSection>
</template>

<style lang="scss" scoped>
.corporateDocumentationPage {
  @include section-investor();

  &__container {
    @include section-investor__container();
  }
}

</style>